import {ComponentPortal} from "@angular/cdk/portal";
import {Injectable, Type} from "@angular/core";
import {ProductCollectionsEnum} from "../../../shared/enums/product-collections.enum";
import {EmptySearchParamsFilterModel} from "../../../shared/models/search/params/filters/empty-search-params-filter.model";
import {CaCollectionFilterComponent} from "../../components/filters/ca-collection-filter/ca-collection-filter.component";
import {CollectionFilterDirective} from "../../components/filters/collection-filter.directive";
import {HlaCollectionFilterComponent} from "../../components/filters/hla-collection-filter/hla-collection-filter.component";
import {CollectionFilterBaseForm} from "../../forms/collection-filter-base.form";

@Injectable({
    providedIn: "root"
})
export class CollectionFilterFactoryService {
    public resolveFilterTypeForCollection(collection: ProductCollectionsEnum)
        : Type<CollectionFilterDirective<CollectionFilterBaseForm<EmptySearchParamsFilterModel>, EmptySearchParamsFilterModel>> {

        let filter: Type<CollectionFilterDirective<CollectionFilterBaseForm<EmptySearchParamsFilterModel>, EmptySearchParamsFilterModel>> = null;

        switch (collection) {
            case ProductCollectionsEnum.CA: {
                filter = CaCollectionFilterComponent;
                break;
            }
            case ProductCollectionsEnum.ECACCHLA: {
                filter = HlaCollectionFilterComponent;
                break;
            }
            default:
                throw new Error("Unknown search scope.");
        }

        return filter;
    }

    public createCollectionFilterPortal(collection: ProductCollectionsEnum)
        : ComponentPortal<CollectionFilterDirective<CollectionFilterBaseForm<EmptySearchParamsFilterModel>, EmptySearchParamsFilterModel>> {

        const filter = this.resolveFilterTypeForCollection(collection);

        return new ComponentPortal(filter);
    }
}
